import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Section84_1FormFactory } from './section-84_1-form.factory';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  Section84_1Options,
} from '../../../../../../../../../../../common/src/options/calculations/section-84_1/section-84_1.options';
import { TranslateService } from '@ngx-translate/core';
import { CalculationStore } from '../../../../../stores/calculation.store';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { FormStateEnum } from '@magieno/angular-advanced-forms';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import {
  Section84_1ShareClassOptions,
} from '../../../../../../../../../../../common/src/options/calculations/section-84_1/section-84_1-share-class.options';
import {
  Section84_1MetadataOptions,
} from '../../../../../../../../../../../common/src/options/calculations/section-84_1/section-84_1-metadata.options';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import { CalculationBaseForm } from '../../../base-form/form/base-form/calculation-base.form';
import { CalculationsUtils } from '../../../../../utils/calculations.utils';
import { AlertMessageStore } from '../../../../../../core/stores/alert-message.store';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import {
  CalculationKeynameEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import { merge, Subscription } from 'rxjs';
import { ImportManager } from '../../../../../managers/import.manager';
import { FormChangeManager } from '../../../../../managers/form-change.manager';
import { CalculationLifecycleManager } from '../../../../../managers/calculation-lifecycle.manager';
import { EventManager } from '../../../../../../core/managers/event.manager';


@Component({
  selector: 'app-section-84_1-form',
  templateUrl: './section-84_1-form.component.html',
  styleUrls: ['./section-84_1-form.component.scss'],
  standalone: false,
})
export class Section84_1FormComponent extends CalculationBaseForm<Section84_1Options> implements OnInit, OnDestroy {

  calculationKeynameEnum = CalculationKeynameEnum;

  isSection84_1Collapsed: boolean = false;
  isSection84_1Applicable: boolean;

  isExecuteButtonEnabled: boolean = false;

  onApplicabilityChangeSubscription: Subscription;

  constructor(public readonly formFactory: Section84_1FormFactory,
              calculationStore: CalculationStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              private readonly changeDetectorRef: ChangeDetectorRef,
              importManager: ImportManager,
              calculationLifecycleManager: CalculationLifecycleManager,
              formChangeManager: FormChangeManager,
              eventManager: EventManager,
  ) {
    super(formFactory, calculationStore, translateService, activatedRoute, modalService, router, optionsMapper, calculationsUtils, alertMessageStore, CalculationKeynameEnum.Section84_1, importManager, calculationLifecycleManager, formChangeManager, eventManager);
    this.optionsType = Section84_1Options;
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get formMetadata(): AdvancedFormGroup<Section84_1MetadataOptions> {
    return this.form.formElements.metadata as AdvancedFormGroup<Section84_1MetadataOptions>;
  }

  get isRollover(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.formMetadata.formElements.isRollover as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get shareClasses(): AdvancedFormArray<Section84_1ShareClassOptions> {
    return this.form.formElements.shareClasses as AdvancedFormArray<Section84_1ShareClassOptions>;
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.onApplicabilityChangeSubscription = merge(
      this.form.formElements.areTransferredSharesCanadianShares.value$,
      this.form.formElements.areTransferredSharesCapitalPropertyForTheSeller.value$,
      this.form.formElements.isSellerAnIndividualOrATrust.value$,
      this.form.formElements.isSellerACanadianResident.value$,
      this.form.formElements.isBuyerACorporation.value$,
      this.form.formElements.areBuyerAndSellerAtArmsLength.value$,
      this.form.formElements.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction.value$,
    ).subscribe((value) => {
      this.refresh();
    });
  }

  refresh() {
    this.handleSection84_1Visibility();
    this.changeDetectorRef.detectChanges();
  }

  handleSection84_1Visibility() {
    const isSection84_1Applicable =
      this.form.value.areTransferredSharesCanadianShares === true &&
      this.form.value.areTransferredSharesCapitalPropertyForTheSeller === true &&
      this.form.value.isSellerAnIndividualOrATrust === true &&
      this.form.value.isSellerACanadianResident === true &&
      this.form.value.isBuyerACorporation === true &&
      this.form.value.areBuyerAndSellerAtArmsLength === true &&
      this.form.value.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction === true;

    if (this.isSection84_1Applicable !== isSection84_1Applicable) {
      this.isSection84_1Applicable = isSection84_1Applicable;

      if (isSection84_1Applicable) {
        this.enableSection84_1();
      } else {
        this.disableSection84_1();
      }
    }

    //if(notIsSection84_1Applicable === this.isSection84_1Applicable /*|| (this.isSection84_1Applicable === undefined && notIsSection84_1Applicable === true)*/){
    //     this.isSection84_1Applicable = !notIsSection84_1Applicable;
    //     if (notIsSection84_1Applicable === false) {
    //         this.enableSection84_1();
    //     } else {
    //         this.disableSection84_1();
    //     }
    //}
  }

  disableSection84_1() {
    this.isSection84_1Collapsed = true;
    this.form.formElements.paidUpCapitalOfGiftedShares.disable();
    this.form.formElements.paidUpCapitalOfGiftedShares.setValue(undefined);
    // this.formService.form.formElements.paidUpCapitalOfGiftedShares.setState(FormStateEnum.Valid);
    // this.formService.form.formElements.nonShareConsideration.disable();
    // this.formService.form.formElements.nonShareConsideration.updateModel(undefined);
    // this.formService.form.formElements.nonShareConsideration.setState(FormStateEnum.Valid);
    this.form.formElements.capitalGainsOnTheShareDeclaredAfter1984.disable();
    this.form.formElements.capitalGainsOnTheShareDeclaredAfter1984.setValue(undefined);
    (this.form.formElements.capitalGainsOnTheShareDeclaredAfter1984 as AdvancedFormControl<number, number, number>).state = FormStateEnum.Valid;
    this.form.formElements.wereSharesAcquiredAfter1971.disable();
    this.form.formElements.wereSharesAcquiredAfter1971.setValue(undefined);
    (this.form.formElements.wereSharesAcquiredAfter1971 as AdvancedFormControl<boolean, boolean, boolean>).state = FormStateEnum.Valid;
    this.disableAcquiredBefore1971();
  }

  disableAcquiredBefore1971() {
    this.form.formElements.fairMarketValueOnValuationDayOfTransferredShares.disable();
    this.form.formElements.fairMarketValueOnValuationDayOfTransferredShares.setValue(undefined);
    (this.form.formElements.fairMarketValueOnValuationDayOfTransferredShares as AdvancedFormControl<number, number, number>).state = FormStateEnum.Valid;
    this.form.formElements.actualCostOnJanuary1972OfTransferredShares.disable();
    this.form.formElements.actualCostOnJanuary1972OfTransferredShares.setValue(undefined);
    (this.form.formElements.actualCostOnJanuary1972OfTransferredShares as AdvancedFormControl<number, number, number>).state = FormStateEnum.Valid;
    this.form.formElements.receivedDividendChoice83OnTransferredShares.disable();
    this.form.formElements.receivedDividendChoice83OnTransferredShares.setValue(undefined);
    (this.form.formElements.receivedDividendChoice83OnTransferredShares as AdvancedFormControl<number, number, number>).state = FormStateEnum.Valid;
  }

  enableSection84_1() {
    this.isSection84_1Collapsed = false;
    this.form.formElements.paidUpCapitalOfGiftedShares.enable();
    // this.formService.form.formElements.nonShareConsideration.enable();
    this.form.formElements.capitalGainsOnTheShareDeclaredAfter1984.enable();
    this.form.formElements.wereSharesAcquiredAfter1971.enable();
    this.enableAcquiredBefore1971();
  }

  enableAcquiredBefore1971() {
    this.form.formElements.fairMarketValueOnValuationDayOfTransferredShares.enable();
    this.form.formElements.actualCostOnJanuary1972OfTransferredShares.enable();
    this.form.formElements.receivedDividendChoice83OnTransferredShares.enable();
  }

  disableExecuteButton() {
    this.isExecuteButtonEnabled = false;
  }

  async removeShareClass(shareClassIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent);
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette catégorie d\'actions';
    modal.closed.subscribe(async result => {
      if (result === true) {
        // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
        (this.form.formElements.shareClasses as AdvancedFormArray<Section84_1ShareClassOptions>).delete(shareClassIndexToRemove);

        return;
      }
    });

    return;
  }
}
